
<p-dialog [(visible)]="visibleLukiNewClientModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="closeModal()">
  <!-- CREAR CUENTA LUKI -->
  <div class="dialog" *ngIf="step === steps.createAccount">
    <form action="">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info">
            <h2 class="titleFlex"><span>Crear cuenta en</span><i><img src="assets/images/logos/luki-logo.png" alt="LUKI"></i></h2>
            <p>Para que empieces de inmediato, te crearemos una <strong>cuenta en Luki</strong> ahora mismo, sin ningún costo asociado.</p>
            <p class="pt-20">¿Estás de acuerdo?</p>
          </div>
          <div class="dialog__btn">
            <button pButton pRipple type="button" label="Sí, estoy de acuerdo" class="p-button-primary p-button-raised p-button-rounded w-full" [loading]="isLoading()" (click)="onRegisterNewUser()"></button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- CASH IN -->
  <div class="dialog" *ngIf="step === steps.accountCreated && isAccountCreated()">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Cash IN</h2>
          <p>Tu cuenta ha sido creada. Ahora podemos enviar el dinero a tu wallet: <strong><span class="noWrap">{{country.phoneCountryCode + request?.person.phone  }}</span></strong>.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple type="submit" label="Sí, enviar el dinero a mi wallet" class="p-button-primary p-button-raised p-button-rounded w-full" [loading]="isLoading()" (click)="onLukiPayment()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
